<template>
	<QrcodeNavBannerShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavBannerShell from '../shared/QrcodeNavBannerShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavBanner',
		components: { QrcodeNavBannerShell },
		mixins: [qrcodeNavMixin],
	};
</script>
